import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import Select from "react-select"
import { SectionContext } from "../../context/sectionContext"
import { ErrorContext } from "../../context/errorContext"
import {JourneyContext} from "../../context/journeyContext"
import { getValueFromJourney,getValueFromLookup, isEquitasChannel } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import * as lookup from "../../../../static/lookup.json"
import { RepeatableContext } from "../../context/repeatableContext"
import { auto } from "async"
import { ConditionContext } from "../../context/conditionContext"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;


  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }
    
    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.55rem 0;
      padding-bottom: 0;
    }

    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;
        padding-right: 4px !important;    
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
      background:var(--lumiq-bg)

    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 2px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`
// const customStyles = {
//   option: (provided) => ({
//     ...provided,
//     // padding: 0,
//     zIndex:9999
//   }),
//   control: () => ({
//     // display:'flex'
//     // none of react-select's styles are passed to <Control />
//   }),
//   input:()=>({

//   }),
//   singleValue: (provided, state) => {
//     // const opacity = state.isDisabled ? 0.5 : 1;
//     // const transition = 'opacity 300ms';

//     // return { ...provided, opacity, transition };
//   }
// }

export default function RepeatableComponentTextSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState, fieldRefs, scrollToFirstError, scrollFieldToTop] = useContext(ErrorContext)
  const [repeatableState,setRepeatableState] = useContext(RepeatableContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState] = useContext(ConditionContext)

  const validate = (target) =>  {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    }else{
      temp1 = []
    }
    if (props.data.required) {
    //   required field validation
      if(!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]){
        // console.log("dchdh1", props, sectionState)
        temp1[props.index] = `Select ${lineCapital(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}`
        
        temp = temp1
        setErrorState( prev => {
            return ({
            ...prev,
            [props.data.formControlKey]: temp
            })
        })
        return 
      }
      if((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])){
        temp1[props.index] = `Select ${lineCapital(getValueFromLookup(
          "label",
          props.data.label
        )) || props.data.label}`
       
        temp = temp1
        setErrorState( prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }else{
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      temp1[props.index] = ""
      temp = temp1
      if(target.value){
        // console.log("dchdh4", props, sectionState)
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
  }

  useEffect(() => {
    validate({value: (sectionState.sectionData[props.data.formControlKey]? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")})
    if(props.data.formControlKey === "nomineeFullNameTitle" && sectionState.sectionData?.["nomineeFullNameTitle"] && sectionState.sectionData["nomineeFullNameTitle"][props.index]){
      autoFill({value: sectionState.sectionData["nomineeFullNameTitle"][props.index] })
    }
  },[sectionState.sectionData[props.data.formControlKey]?.[props.index]])

  
  useEffect(() => {
    if(!sectionState.sectionData[props.data.formControlKey]?.[props.index]){
      if((props.data.formControlKey === "contactCountryCode") || (props.data.formControlKey === "AlternateMobCountryCode") ){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "+91"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "+91"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
      }else if(props.data.formControlKey.toLowerCase().includes("country")){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "IN"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "IN"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
      }
      // else if((props.data.formControlKey === "nomineeFullNameTitle")){
      //   let temp
      //   if (sectionState.sectionData[props.data.formControlKey]) {
      //     let temp1 = sectionState.sectionData[props.data.formControlKey]
      //     temp1[props.index] = "MR"
      //     temp = temp1
      //   }else{
      //     let temp1 = []
      //     temp1[props.index] = "MR"
      //     temp = temp1
      //   }
      //   setSectionState((prev) => {
      //     return ({
      //       ...prev,
      //       sectionData: {
      //         ...prev.sectionData,
      //         [props.data.formControlKey]: temp
      //       },
      //     })
      //   })
      // }
    }
  }, [props.sectionId])

  useEffect(() => {
    if (props.data.formControlKey === "nomineeFullNameTitle" && props.sectionId === "nomineeDetailsSection"){
      let relationshipLookup
      let martialStatus = conditionState["pageISelect360FillProposalForm.personalDetailsSection.maritalStatus"]
      if(sectionState?.sectionData?.["nomineeFullNameTitle"]?.[props.index] === "MR"){
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }else if (sectionState?.sectionData?.["nomineeFullNameTitle"]?.[props.index] === "MS" || sectionState?.sectionData["nomineeFullNameTitle"]?.[props.index] === "MRS"){
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAFemale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAFemaleUnMarried"
        }
      }else{
        // by default gender selected is M
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }
      if(sectionState?.sectionData?.["gender"] && sectionState?.sectionData?.["gender"]?.[props.index] === "T"){
        relationshipLookup = "nomineeRelationshipWithLA"
      }
      
      setTimeout(() => {
        if(!Object.keys(lookup[relationshipLookup][0]).includes(sectionState?.sectionData?.["nomineeRelationshipWithUser"]?.[props.index]) && relationshipLookup.includes("UnMarried")){
          let tempState
          if (sectionState.sectionData["nomineeRelationshipWithUser"]) {
            let temp1 = sectionState.sectionData["nomineeRelationshipWithUser"]
            temp1[props.index] = ""
            tempState = temp1
          } else {
            let temp1 = []
            temp1[props.index] = ""
            tempState = temp1
          }
          console.info("changing state...")
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["nomineeRelationshipWithUser"]: tempState,
              }
            })
          })
        }
      },1500)
      

      let temp = JSON.parse(JSON.stringify(repeatableState.nomineePersonalDetail))
        console.log(temp, "before")
        let nominee = JSON.parse(JSON.stringify(temp[props.index]))
        console.log(nominee, "Nbefore")
        // nominee.components[4]["disabled"] = true
        nominee.components[3]["lookupKey"] = relationshipLookup
        console.log(nominee, "Nafter")
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })


    }
    
  },[props.sectionId])

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = target.value;
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = target.value
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    } else {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = target.value;
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = target.value
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
    }
    validate(target)
    console.log(sectionState, "section state")
  }


  const autoFill = (target) => {
    if(props.data.formControlKey.toLowerCase().includes("country")){
      //Temp Indexes will be used either in if or else
      
      let temp = JSON.parse(JSON.stringify(repeatableState.nomineePersonalDetail))
      let nominee = JSON.parse(JSON.stringify(temp[props.index]))

      if (sectionState.sectionData[props.data.formControlKey][props.index] !== "IN") {
        let tempState
        if (sectionState.sectionData["state"]) {
          let temp1 = sectionState.sectionData["state"]
          temp1[props.index] = "NR";
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = "NR"
          tempState = temp1
        }

        let tempCity
        if (sectionState.sectionData["cityNominee"]) {
          let temp1 = sectionState.sectionData["cityNominee"]
          temp1[props.index] = "OTHERS"
          tempCity = temp1
        } else {
          let temp1 = []
          temp1[props.index] = "OTHERS"
          tempCity = temp1
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["state"]: tempState,
              ["cityNominee"]: tempCity,
            }
          })
        })
        nominee.components[12]["min_len"] = 1
        nominee.components[12]["max_length"] = 9
        nominee.components[12]["regex"] = "/^[a-zA-Z0-9]+$/"
        nominee.components[12]["__typename"] = "ComponentCmpTagTextString"
        if(nominee.components[13]) nominee.components[13]["disabled"] = true;
        if(nominee.components[14]) nominee.components[14]["disabled"] = true;
        
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })
      } else {
        let tempState
        if (sectionState.sectionData["state"]) {
          let temp1 = sectionState.sectionData["state"]
          temp1[props.index] = "";
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = ""
          tempState = temp1
        }

        let tempCity
        if (sectionState.sectionData["cityNominee"]) {
          let temp1 = sectionState.sectionData["cityNominee"]
          temp1[props.index] = "";
          tempCity = temp1
        } else {
          let temp1 = []
          temp1[props.index] = ""
          tempCity = temp1
        }

        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["state"]: tempState,
              ["cityNominee"]: tempCity,
            }
          })
        })

        nominee.components[12]["min_len"] = 6
        nominee.components[12]["regex"] = null
        nominee.components[12]["__typename"] = "ComponentCmpTagNumber"
        if(nominee.components[13]) nominee.components[13]["disabled"] = false;
        if(nominee.components[14]) nominee.components[14]["disabled"] = false;
        
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })
      }
    }else if(props.data.formControlKey === "nomineeFullNameTitle"){
      let gender
      let relationshipLookup
      let martialStatus = conditionState["pageISelect360FillProposalForm.personalDetailsSection.maritalStatus"]
      if(sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR"){
        gender = "M"
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }else if (sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MS" || sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MRS"){
        gender = "F"
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAFemale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAFemaleUnMarried"
        }
      }else{
        // by default gender selected is M
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }
      if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index] === "T"){
        gender = "T"
        relationshipLookup = "nomineeRelationshipWithLA"
      }
      console.log(repeatableState, "asff")
      let tempState
        if (sectionState.sectionData["gender"]) {
          let temp1 = sectionState.sectionData["gender"]
          temp1[props.index] = gender
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = gender
          tempState = temp1
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["gender"]: tempState,
            }
          })
        })
        if(errorState["gender"] && errorState["gender"][props.index]){
          let temp
          let temp1 = errorState["gender"]
          temp1[props.index] = ""
          temp = temp1
          setErrorState( prev => {
            return ({
              ...prev,
              ["gender"]: temp
            })
          })
          // if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index]){
          //   if(sectionState.sectionData["gender"][props.index] === "M" && sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR")
          // }
        }
        if(sectionState.sectionData["nomineeRelationshipWithUser"] && sectionState.sectionData["nomineeRelationshipWithUser"][props.index] && !Object.keys(lookup[relationshipLookup][0]).includes(sectionState.sectionData["nomineeRelationshipWithUser"][props.index])){
          let tempState
          if (sectionState.sectionData["nomineeRelationshipWithUser"]) {
            let temp1 = sectionState.sectionData["nomineeRelationshipWithUser"]
            temp1[props.index] = ""
            tempState = temp1
          } else {
            let temp1 = []
            temp1[props.index] = ""
            tempState = temp1
          }
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["nomineeRelationshipWithUser"]: tempState,
              }
            })
          })
        }
        
        let temp = JSON.parse(JSON.stringify(repeatableState.nomineePersonalDetail))
        console.log(temp, "before")
        let nominee = JSON.parse(JSON.stringify(temp[props.index]))
        console.log(nominee, "Nbefore")
        // nominee.components[4]["disabled"] = true
        nominee.components[3]["lookupKey"] = relationshipLookup
        console.log(nominee, "Nafter")
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })
    }
  }

  // const getSelectedValue = () => {
  //   let key = Object.keys(props.options).filter(function(key) {return props.options[key] === sectionState.sectionData[props.data.formControlKey] })[0];
  //   console.log(key,"dhbe")
  //   return key
  // }
  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }
  let options = props.options
  options = Object.entries(options).map(([key, val]) => ({
    value: key,
    label: val,
  }))
  return (
    <>
      <SelectContainer ref={el => { if (el && props.data?.formControlKey) fieldRefs.current[`${props.data.formControlKey}_${props.index}`] = el }} channel={props.channel} className={`input-container ${props.data.disabled?'disable-input':''} ${props.data?.freeze?'freeze-input':''}` }>
        <label htmlFor={props.data.label} className="input-label">
          {/* {props.data.label} */}
          {lineCapital(getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}
          {isEquitasChannel(props.channel) && props.data.required && <span className="equitas-required-marker"> *</span>}
        </label>
        <Select
           className={`${props.data.requiredError?'':'requiredErrorNull'}`}
          // styles={customStyles}
          options={options}
          name={props.data.label}
          key={props.data.formControlKey}
          id="InputSelect"
          classNamePrefix="custom-select option"
          menuPlacement="auto"
          required={props.data.required}
          disabled={props.data.disabled}
          isSearchable={options.length > lookup["searchableDropdownLimit"]}
          onChange={handleChange}
          tabIndex={props.data.disabled || props.data?.freeze?-1:0}
          // value={
          //   sectionState.sectionData[props.data.formControlKey]
          //     ? getKeyByValue(
          //         options,
          //         sectionState.sectionData[props.data.formControlKey]
          //       )
          //     : ""
          // }
          value={
            sectionState.sectionData[props.data.formControlKey] && sectionState.sectionData[props.data.formControlKey][props.index]
              ? getKeyByValue(
                  options,
                  sectionState.sectionData[props.data.formControlKey][props.index]
                )
              : ""
          }
          onBlur={e => autoFill(e.target)}
          onFocus={() => scrollFieldToTop(`${props.data.formControlKey}_${props.index}`)}
        ></Select>
        <span className="input-error">
          {props.showError && errorState?.[props.data.formControlKey]?.[props.index]}
        </span>
      </SelectContainer>
    </>
  )
}
